module.exports = __webpack_public_path__ + "img/skill_level_4_svg.5b6bcc44.svg";